if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.prevButton = this.querySelector('[data-product-modal-prev]');
        this.nextButton = this.querySelector('[data-product-modal-next]');
        this.closeButton = this.querySelector('[id^="ModalClose-"]');
        this.handleArrowNavigation = this.handleArrowNavigation.bind(this);

        this.prevButton?.addEventListener('click', () => this.changeMedia(-1));
        this.nextButton?.addEventListener('click', () => this.changeMedia(1));
        this.addEventListener('keyup', this.handleArrowNavigation);

        [this.prevButton, this.nextButton, this.closeButton].forEach((button) => {
          button?.addEventListener('pointerup', (event) => event.stopPropagation());
          button?.addEventListener('click', (event) => event.stopPropagation());
        });
      }

      hide() {
        this.querySelectorAll('[data-media-id].active').forEach((element) => element.classList.remove('active'));
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      get mediaItems() {
        return Array.from(this.querySelectorAll('[data-media-id]'));
      }

      handleArrowNavigation(event) {
        if (!this.hasAttribute('open')) return;
        if (event.code === 'ArrowLeft') this.changeMedia(-1);
        if (event.code === 'ArrowRight') this.changeMedia(1);
      }

      changeMedia(step) {
        const mediaItems = this.mediaItems;
        if (!mediaItems.length) return;

        const currentIndex = mediaItems.findIndex((element) => element.classList.contains('active'));
        const safeCurrentIndex = currentIndex === -1 ? 0 : currentIndex;
        const nextIndex = (safeCurrentIndex + step + mediaItems.length) % mediaItems.length;
        this.showMediaByIndex(nextIndex);
      }

      showMediaByIndex(index) {
        const mediaItems = this.mediaItems;
        const activeMedia = mediaItems[index];
        if (!activeMedia) return;

        mediaItems.forEach((element) => element.classList.remove('active'));

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }

      showActiveMedia() {
        const mediaId = this.openedBy?.getAttribute('data-media-id');
        const mediaItems = this.mediaItems;
        const activeIndex = mediaItems.findIndex((element) => element.getAttribute('data-media-id') === mediaId);
        this.showMediaByIndex(activeIndex === -1 ? 0 : activeIndex);
      }
    }
  );
}
